module.exports = __webpack_public_path__ + "img/guest-option.5cd094d3.svg";